import { observer } from 'mobx-react-lite';
import { TriangleAlert } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Modal } from '@/components/ui/modal';
import { COMMON } from '../../constants/commonText.constants';
import { useTran } from '../../hooks/useTran';

const DeleteConfirmModal = observer(({ handleDelete, name, isDeleteConfirmModalOpen, closeDeleteConfirmModal }) => {
	const { t } = useTran();

	return (
		<div>
			<Modal
				isOpen={isDeleteConfirmModalOpen}
				title={t(COMMON.DELETE_CONFIRMATION)}
				size={'small'}
				isStatic
				footer={
					<div className="flex gap-2 items-center justify-end">
						<Button
							variant="secondary"
							onClick={closeDeleteConfirmModal}
							id="deleteModalClose"
						>
							{t(COMMON.CANCEL)}
						</Button>
						<Button
							variant="destructive"
							id="delete_confirm"
							onClick={handleDelete}
						>
							{t(COMMON.DELETE)}
						</Button>
					</div>
				}
			>
				<div className="flex gap-3 py-3 items-center">
					<TriangleAlert className="text-destructive" />
					<span>
						{t(COMMON.ARE_U_SURE)} <strong>{name}</strong> ?
					</span>
				</div>
			</Modal>
		</div>
	);
});

export default DeleteConfirmModal;
